import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/devolucao')({
    beforeLoad: () => {
        return validateRoute({
            fintech: true,
            validatePermission: ({ upp_venda_devolucao }) =>
                isPermissionParcialOrFull(upp_venda_devolucao),
        });
    },
});
